import { ContentContainer } from '../base/contentContainer/contentContainer';
import { Columns } from '../base/grid';
import media from '../../constants/media';
import styled, { css } from 'styled-components';

export const Root = styled.div`
	margin-top: 100px;
	position: sticky;
	top: 0;
	z-index: 100;
`;

export const StickyContentContainer = styled(ContentContainer)`
	margin: 10px auto;
	padding-top: 10px;
	padding-bottom: 10px;
	background-color: white;
`;

export const MenuItem = styled.div<{ isMobileItem: boolean; isFirstMobileMenuItem: boolean; isIconRotated: boolean }>`
	:hover {
		background-color: #f6f6f6;
	}

	text-align: center;

	${({ isMobileItem, isFirstMobileMenuItem }) =>
		(!isMobileItem || isFirstMobileMenuItem) &&
		css`
			padding: 24px 32px;
			border-radius: 8px;
			box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
			flex: 1;
			background-color: white;
		`}

	${({ isMobileItem, isFirstMobileMenuItem }) =>
		isMobileItem &&
		!isFirstMobileMenuItem &&
		css`
			padding: 12px 32px;
			background-color: white;
		`}

	svg {
		position: absolute;
		right: 2rem;
		transition: transform 0.3s ease-in-out;
		transform: ${({ isIconRotated }) => (isIconRotated ? 'rotate(-90deg)' : 'none')};
	}
`;

export const DesktopMenu = styled(Columns)`
	display: none;

	${media.desktopSmall`
		display: flex;
	`};
	gap: 2rem;
`;

export const MobileMenu = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	${media.desktopSmall`
		display: none;
	`};
`;

export const MobileMenuWrapper = styled.div`
	position: relative;
	min-width: 50%;
`;

export const MobileMenuDropdown = styled.div<{ isOpen: boolean }>`
	position: absolute;
	width: 100%;
	border-radius: 8px;
	box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
	transition: opacity 0.3s ease-in-out, max-height 0.3s ease-in-out;
	opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
	max-height: ${({ isOpen }) => (isOpen ? '100vh' : '0')};
	overflow: hidden;
`;

export const StyledLink = styled.a`
	color: #3c3c3c;
`;
